import { render, staticRenderFns } from "./VerticalAlignment.vue?vue&type=template&id=1374d998&"
import script from "./VerticalAlignment.vue?vue&type=script&lang=js&"
export * from "./VerticalAlignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports